import { FormBaseType } from "@green0meter/api-client";

export const CSOB_SK_CONFIG = {
  formBaseType: FormBaseType.CsobSk,
  welcomeBanner: {
    titleKey: "csobskhub.welcome",
    textKey: "csobskhub.welcomeText",
    color: "blue",
    icon: "accountant",
  },
  collectData: {
    titleKey: "csobskCollectionDataTitle",
    descriptionKey: "csobskCollectionDataDescription",
    color: "teal",
    icon: "data-gathering",
    buttonTextKey: "csobskCollectionDataButtonStart",
    noFormsTextKey: "collectData.noFormsCreated",
  },
  reports: {
    titleKey: "csobsk.hub.reports.title",
    type: "csobsk-reports",
    noReportsTextKey: "csobsk.hub.reports.noReports",
    fillFormTextKey: "csobsk.hub.reports.fillForm",
  },
};
